export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            wrapNativeOnMobile: false,
            fakeDropInBody: false,
            maxVisibleItems: 7,
        });
        jcf.replaceAll();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js